<prlw-title-label-ui
  [title]="title$ | async"
  [svgName]="svgName$ | async"
  [appearance]="appearance$ | async"
  [isPro]="isPro$ | async"
>
</prlw-title-label-ui>
